/** SessionStorage key for shared credentials — enables re-verify on page reload */
export const getCredentialsKey = (hash: string) => `shared_credentials_${hash}`;
